import { find, propEq } from 'ramda';

export const findById = (id, listOfObjects, prop = 'id') =>
  find(propEq(prop, id))(listOfObjects);
